<template>
  <div class="w-100" v-if="showDiv">
    <div class="container-fluid px-2">
      <div class="row align-items-center mb-3 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100 d-flex align-items-center justify-content-between justify-content-lg-start"
          >
            <span class="carousel_title_new">{{ title }}</span>
            <div
              class="d-flex flex-row align-items-center ml-3 view-all-wrapper"
              @click="viewMore()"
            >
              <span class="see-more-text cursor-pointer">View All</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-0 latest-tv-rails-content" id="newsSorotan">
        <div class="w-100">
          <div class="owl-carousel owl-theme" :id="titleCarousel">
            <div
              class="item"
              v-for="item_vod in items"
              :key="item_vod.id"
              @mouseover="mouseOver"
              @mouseout="mouseOver"
            >
              <vodCard
                :image="imgFiltering(item_vod)"
                :imageFeature="imgFiltering(item_vod, 'feature')"
                :title="item_vod.longTitle"
                :link="checkLink(item_vod)"
                :latestTag="formatTimestamp(item_vod.dateAvailability)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100" v-else></div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import noimage from "../../../assets/noimage.png";
import vodCard from "../../cards/v2/vodCard.vue";
export default {
  name: "sponsor-rails",
  props: ["title", "datasource", "cat", "cat_id"],
  data: function() {
    return {
      items: [],
      titleCarousel: this.title.replace(/\s/g, "").toLowerCase(),
      noimage: noimage,
      showMore: false,
      contenttype: this.datasource,
      hover: false,
      showDiv: true,
      firstID: "",
      backgroundImgDesktop: "",
      backgroundImgMobile: "",
      mobile: false,
      desktop: false,
    };
  },
  components: { vodCard },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },

    imageLoadError(event) {
      event.target.src = noimage;
    },
    viewMore() {
      this.$router.replace(
        `/play?scheme=208&p_type=true&id=${this.firstID}&eps_id=`
      );
    },
    goTo(link) {
      this.$router.push(link);
    },
    imgFiltering(item, type = null) {
      let imgurl;
      const hasThumb =
        item.data && item.data.images && item.data.images.thumbnail;
      const hasTitle = item.data && item.data.images && item.data.images.title;
      const hasFeature =
        item.data && item.data.images && item.data.images.feature;

      // First try to get the specifically requested type if it exists
      if (type === "thumbnail" && hasThumb) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.thumbnail.path;
      } else if (type === "title" && hasTitle) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" + item.data.images.title.path;
      } else if (type === "feature" && hasFeature) {
        imgurl =
          "https://rtb-images.glueapi.io/320x0/" +
          item.data.images.feature.path;
      }
      // Fall back to original hierarchy if requested type doesn't exist or no type specified
      else {
        if (hasThumb) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.thumbnail.path;
        } else if (hasTitle) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.title.path;
        } else if (hasFeature) {
          imgurl =
            "https://rtb-images.glueapi.io/320x0/" +
            item.data.images.feature.path;
        } else {
          imgurl =
            "https://cdn-rtb.glueapi.io/v1/content/" +
            item.id +
            "/image/300x0/images.title";
        }
      }

      return imgurl;
    },
    checkLink(item) {
      var idSchema;
      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (idSchema == "204") {
        //pod episode
        link = "/podcastplayer?id=" + item.id;
      }

      return link;
    },
    checkIndexForMore() {
      var listlength = this.items;
      if (listlength.length > 8) {
        this.showMore = true;
      }
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 4,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-md"></span>',
          '<span class="fa fa-chevron-right fa-md"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 8,
            stagePadding: 4,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 16,
            nav: true,
          },
        },
      });
    },

    async getEpsListContentData(list) {
      let vm = this;
      let promises = [];
      let store = [];

      const dataFromList = list[0];
      // 1. Sort by latest id (descending)
      const sortedData = [...dataFromList].sort((a, b) => b.id - a.id);

      // 2. Slice the first 8 items
      const latestEightItems = sortedData.slice(0, 15);

      latestEightItems.forEach(function(items, idx) {
        if (idx === 0) {
          vm.firstID = items.id;
        }

        const myUrl = `https://cdn-rtb.glueapi.io/v1/content/${
          items.id
        }?format=json`;
        promises.push(axios.get(myUrl));
      });

      Promise.all(promises).then(function(results) {
        results.forEach(function(response, index) {
          const res = response.data.data;
          if (res) {
            vm.items.push(response.data.data);
          }
        });
      });

      var target = document.getElementById(vm.titleCarousel);
      if (vm.items) {
        setTimeout(
          function() {
            Vue.nextTick(
              function() {
                vm.installOwlCarousel(target);
              }.bind(vm)
            );
          }.bind(vm),
          1000
        );
      }
    },

    async initializeContentForStart() {
      var vm = this;
      var newsList = [];

      let response = await axios.get(
        `https://rtb.glueapi.io/v1/content/${vm.cat_id}?fields=data,title`,
        {
          responseType: "json",
        }
      );

      if (response.data) {
        newsList.push(response.data.data.data["news-episode"]);

        this.getEpsListContentData(newsList);
      } else {
        this.showDiv = false;
      }
    },

    deviceCheck() {
      if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
    async getBgImage() {
      //  backgroundImgDesktop: "",
      // backgroundImgMobile: "",

      var vm = this;

      let response = await axios.get(
        `https://rtb-admin.glueapi.io/v2/asset/s3file?bucket=image&folderName=testing`,
        {
          responseType: "json",
        }
      );

      response.data.data.forEach((element) => {
        if (element.id === 5) {
          vm.backgroundImgDesktop = `https://rtb-images.glueapi.io/1200x0/${
            element.key
          }?${Date.now()}`;
        } else if (element.id === 3) {
          vm.backgroundImgMobile = `https://rtb-images.glueapi.io/560x0/${
            element.key
          }?${Date.now()}`;
        }
      });
    },
  },
  beforeMount() {
    setTimeout(
      function() {
        this.initializeContentForStart();
        this.getBgImage();
      }.bind(this),
      1000
    );
  },
  mounted() {
    this.deviceCheck();
  },
};
</script>

<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#newsSorotan .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #newsSorotan .owl-theme:hover {
    z-index: 111;
  }

  #newsSorotan .owl-theme {
    height: auto;
  }
  #newsSorotan .owl-item {
    z-index: 1;
  }
  #newsSorotan .owl-item:hover {
    transition: 0.1s all ease-in-out;
    width: 100%;
    z-index: 2000;
  }

  #newsSorotan .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #newsSorotan .owl-theme .owl-nav {
    position: absolute;
    top: -64px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
    z-index: 11;
  }

  #newsSorotan .owl-prev {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
    z-index: 1;
  }

  #newsSorotan .owl-next {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    z-index: 1;
  }

  #newsSorotan .owl-next span,
  #newsSorotan .owl-prev span {
    color: rgb(0, 0, 0) !important;
  }
}
</style>

<style scoped>
.carousel_title_new {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(250, 185, 19, 1);
}
.view-all-wrapper {
  border-radius: 8px;
  background: rgba(250, 185, 19, 1);
  padding: 6px 12px;
}
.see-more-text {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 1);
}

@media only screen and (max-width: 768px) {
  .carousel_title_new {
    font-size: 18px;
    line-height: 22px;
  }
  .see-more-text {
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
